// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__XYgy-","secondary":"Button_secondary__QwN49","wpp":"Button_wpp__7MC2n","spin":"Button_spin__6FyKA"};